import { render, staticRenderFns } from "./ScreenshotImageItem.vue?vue&type=template&id=6805e26b&"
import script from "./ScreenshotImageItem.vue?vue&type=script&lang=js&"
export * from "./ScreenshotImageItem.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotImageItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VImg,
  VSelect,
})
